module.exports = __webpack_public_path__ + "img/marika_hellmund_7.62ca5f44.jpg";